import get from 'lodash/get';

export const typePerson = (data: any) => {
  const name = get(data, 'name', '');
  const fantasyName = get(data, 'fantasyName', '');
  const companyName = get(data, 'companyName', '');
  return fantasyName || companyName || name;
};
